import React from 'react';
import { SkeletonLoader } from '@sm/webassets';
import './summary-side-bar.scss';

export const SummarySideBarSkeleton: React.FC = () => {
  return (
    <SkeletonLoader
      data-testid="summary-side-bar-loader"
      className="wds-display--block sm-summary-side-bar__skeleton"
      title="Loader"
      height="420px"
      width="320px"
    >
      <rect x="0" y="10" rx="0" ry="0" width="220" height="30" />
      <rect x="0" y="70" rx="0" ry="0" width="320" height="350" />
    </SkeletonLoader>
  );
};

export default SummarySideBarSkeleton;
